

var _constants = require('./lib/constants');

// set public path for chunks on the fly
// more details - https://webpack.js.org/guides/public-path/#on-the-fly
// without it - webpack doesn't know how to resolve path for assets stored in webpack -> output (.build/js)
// in development: staticUrl will be /webapps/hermes/static in case of Hermes
// in production: staticUrl will be pointing to CDN, e.g https://www.paypalobjects.com/web/res/6e6/9af00bdfc93477f08ba3fe44e9589
__webpack_public_path__ = window.meta.staticUrl + '/'; // eslint-disable-line no-undef


window.main = true;

// Angular 1.6.9 adds a `!` as a hash prefix to the url by default.
// This is different behavior than Angular 1.4.7 which didn't add
// a hash prefix. The code snippet below will prevent the hash prefix
// from being added so that after the Angular 1.6.9 upgrade the url
// hash will remain the same.
// Angular 1.4.7: http://.../xoonboarding?token=EC-9CC38595EA0236714#/checkout/signup
// Angular 1.6.9 with out setting the `hashPrefix` to an empty string:
// http://.../xoonboarding?token=EC-9CC38595EA0236714#!/checkout/signup
angular.module('app').config(['$locationProvider', '$compileProvider', function ($locationProvider, $compileProvider) {
    $locationProvider.hashPrefix('');

    // https://github.com/angular/angular.js/blob/master/src/ng/compile.js#L1767
    // If you want to debug an application with angular related information in
    // production environemnt, simply open up your console, and type `angular.reloadWithDebugInfo()`
    // and waits for your current page to reload
    if (process.env.NODE_ENV === 'production') {
        $compileProvider.debugInfoEnabled(false);
    }
    $compileProvider.aHrefSanitizationWhitelist(_constants.constants.regex.protocolsWithDeeplink);
    $compileProvider.cssClassDirectivesEnabled(false); // https://github.com/angular/angular.js/blob/master/src/ng/compile.js#L1892
    $compileProvider.commentDirectivesEnabled(false); // https://github.com/angular/angular.js/blob/master/src/ng/compile.js#L1863
}]);

if (!window.prefetch) {
    window.beacon('info', ['angular_bootstrap_start']);
    angular.bootstrap(document.getElementById('angular_app_container'), ['app']);
    window.beacon('info', ['angular_bootstrap_end']);
    if (window.appPerformanceEvents) {
        // TimeToFrameworkEnd: The moment client has finished bootstrapping framework.
        window.appPerformanceEvents.TimeToFrameworkEnd = parseInt(window.performance.now(), 10);
        window.beacon('info', ['APP_PERFORMANCE_EVENTS'], window.appPerformanceEvents);
    }
    require('./app.js');
}

_constants.constants;


//////////////////
// WEBPACK FOOTER
// ./js/bootstrap.js
// module id = ./js/bootstrap.js
// module chunks = 0